export const TOP_PAGE_PATH = '/';
export const PRODUCT_PAGE_PATH = '/products/[id]';
export const BRAND_PAGE_PATH = '/brands/[id]';
export const BRAND_LIST_PAGE_PATH = '/brands';
export const SEARCH_PAGE_PATH = '/search';
export const CART_PAGE_PATH = '/cart';
export const LARGE_CATEGORY_PAGE_PATH = '/large_categories/[slug]';
export const MIDDLE_CATEGORY_PAGE_PATH = '/middle_categories/[slug]';
export const SMALL_CATEGORY_PAGE_PATH = '/small_categories/[slug]';
export const TINY_CATEGORY_PAGE_PATH = '/tiny_categories/[slug]';
export const RANKING_PAGE_PATH = '/ranking';
export const CAMPAIGN_FANCL_PAGE_PATH = '/campaign-fancl';
export const FAVORITES_PAGE_PATH = '/favorites';
export const PICKUP_SUPPORT_PAGE_PATH = '/pickup_support';
export const PAYMENT_ERROR_PAGE_PATH = '/payment_error';
